/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Compose_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "Uno's suggestion" |
*
* @param {Uno_Compose_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_compose_preview_label = /** @type {((inputs?: Uno_Compose_Preview_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Compose_Preview_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unos Vorschlag")
	return /** @type {LocalizedString} */ ("Uno's suggestion")
});